import { render, staticRenderFns } from "./plaid-app.vue?vue&type=template&id=83528612"
import script from "./plaid-app.vue?vue&type=script&lang=js"
export * from "./plaid-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports